import type { Plan } from "@apps/gwservice/types"
import { RichText } from "~/components/ui/rich-text"
import { fmtRub, pluralizeRu } from "../lib/format"
import { SubscribeButton } from "./subscribe-button"

interface Props {
  plan: Plan
}

const dayForms: readonly [string, string, string] = ["день", "дня", "дней"]
const paidAdjForms: readonly [string, string, string] = ["оплаченный", "оплаченных", "оплаченных"]

export function ExpertDmPlanCard({ plan }: Props) {
  const showCreditHint = plan.creditDays > 0

  return (
    <div className="flex flex-col gap-m px-m">
      <p className="text-base hyphens-auto">
        Написать эксперту можно при оплате годовой подписки на тариф «Участник».
      </p>
      <h2 className="text-xl font-bold">Тариф «{plan.name}»</h2>
      <RichText data={plan.description} />
      <div className="flex flex-col gap-s">
        <SubscribeButton planId={plan.id} period="yearly" size="lg">
          Оплатить {fmtRub(plan.priceYearWithCredit)} ₽ за год
        </SubscribeButton>
        {showCreditHint && (
          <p className="text-sm text-muted-foreground hyphens-auto">
            Цена за год — {fmtRub(plan.priceYearDiscount)} ₽.
            <br />
            Со скидкой за {plan.creditDays} {pluralizeRu(plan.creditDays, paidAdjForms)} {pluralizeRu(plan.creditDays, dayForms)} — {fmtRub(plan.priceYearWithCredit)} ₽
          </p>
        )}
      </div>
    </div>
  )
}
